<template>
  <div class="zhiliu" v-if="hasData">
    <section class="section0 section1">
      <layout2 :title="'系统数据'" :date="date">
        <div class="box">
          <div class="item" v-for="(item, index) in data1" :key="index">
            <p class="label">{{ item.key }}：</p>
            <div>{{ item.value | getTwo}}</div>
            <p>{{item.field==='13'?'A':'V'}}</p>
          </div>
        </div>
      </layout2>
    </section>
    <section class="section0 section2">
      <layout2 :title="'交流数据'" :date="date">
        <div class="item-box">
          <p class="item-label1">Uab</p>
          <p class="item-label2">Ubc</p>
          <p class="item-label3">Uca</p>
        </div>
        <div class="box">
          <div class="item" v-for="(item, index) in data2" :key="index">
            <!-- {{ item.key }} -->
            <!-- <p class="label">{{ item.key.substring(item.key.length-3,item.key.length) }}</p> -->
            <p class="label line-one" v-if="index%3===0">{{ item.key.substring(0,item.key.length-3) }}</p>
            <p v-if="index%3!==0" class="label">    </p>
            <div>{{ item.value | getTwo}}</div>
            <p>V</p>
          </div>
        </div>
      </layout2>
    </section>
    <section class="section0 section3">
      <layout2 :title="'电池信息'" :date="date">
        <div class="box">
          <div class="item" v-for="(item, index) in data3" :key="index">
            <p class="label">{{ item.key }}：</p>
            <div>{{ item.value | getTwo}}</div>
            <p>V</p>
          </div>
        </div>
      </layout2>
    </section>
  </div>
  <div class="nodata" v-else>
    <p>抱歉，当前配电室暂无设备</p>
    <img src="../../../assets/images/nodata2.png" alt="" />
  </div>
</template>

<script>
import layout2 from "../../layout/layout2";
export default {
  components: {
    layout2,
  },
  data() {
    return {
      date: "",
      hasData: true,
      data1: [
        {
          key: "1#输入逆变模块电压",
          value: "0.0",
        },
        {
          key: "2#输入逆变模块电压",
          value: "0.0",
        },
        {
          key: "3#输入逆变模块电压",
          value: "0.0",
        },
        {
          key: "合母电压",
          value: "0.0",
        },
        {
          key: "合母电压",
          value: "0.0",
        },
        {
          key: "合母电压",
          value: "0.0",
        },
      ],
      data2: [
        {
          key: "一路输入AB相电压",
          value: "0.0",
        },
        {
          key: "一路输入BC相电压",
          value: "0.0",
        },
        {
          key: "一路输入CA相电压",
          value: "0.0",
        },
        {
          key: "二路输入AB相电压",
          value: "0.0",
        },
        {
          key: "二路输入BC相电压",
          value: "0.0",
        },
        {
          key: "二路输入CA相电压",
          value: "0.0",
        },
      ],
      data3: [
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
        {
          key: "01#电池电压",
          value: "0.0",
        },
      ],
      topicList: [],
    };
  },
  created() {
    // this.date = this.date
    //   ? this.date
    //   : this.$dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
    this.getDCScreen();
  },
  computed: {
    roomId() {
      return this.$store.state.roomId;
    },
  },
  watch: {
    roomId() {
      this.getDCScreen();
    },
  },
  methods: {
    // 获取直流屏数据
    getDCScreen() {
      this.hasData = true;
      this.$http
        .post("bma-distribution-service/realTime/getDCScreen", {
          equipmentRoomId: this.roomId,
        })
        .then((res) => {
          if (res.data && res.data.fieldGroups) {
            res.data.fieldGroups.forEach((item) => {
              let arr = [];
              item.equipmentFieldGroups.forEach((item1) => {
                let obj = {
                  field: item1.field,
                  key: item1.fieldName,
                  value: item1.fieldValue,
                };
                arr.push(obj);
              });
              if (item.smallType == 1) {
                this.data1 = arr;
              }
              if (item.smallType == 2) {
                this.data2 = arr;
              }
              if (item.smallType == 3) {
                this.data3 = arr;
              }
            });
            res.data.subscribeFields.forEach((i) => {
              if (this.topicList.indexOf(i.subscribeField) == -1) {
                this.topicList.push(i.subscribeField);
              }
              this.$timeing(i.subscribeField, i.subscribeField, (res) => {
                let data = JSON.parse(res.body);
                this.date = data.time
                  ? data.time
                  : '';
                this.data1.forEach((i) => {
                  if (data.field.indexOf(i.field) > -1) {
                    i.value = data.value;
                  }
                });
                this.data2.forEach((i) => {
                  if (data.field.indexOf(i.field) > -1) {
                    i.value = data.value;
                  }
                });
                this.data3.forEach((i) => {
                  if (data.field.indexOf(i.field) > -1) {
                    i.value = data.value;
                  }
                });
              });
            });
          } else {
            this.hasData = false;
          }
        });
    },
  },
  beforeDestroy() {
    this.topicList.forEach((item) => {
      this.$clearTimeing(item);
    });
  },
};
</script>

<style lang="less" scoped>
.zhiliu {
  background: #ececec;
  .section0 {
    width: 1619px;
    height: 200px;
    margin-bottom: 10px;
    .box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding-top: 30px;
      box-sizing: border-box;
      .item {
        display: flex;
        align-items: center;
        width: 500px;
        box-sizing: border-box;
        padding-left: 50px;
        margin-bottom: 15px;
        p {
          font-size: 14px;
          color: #0e223d;
          &.label {
            width: 150px;
            font-weight: 600;
            text-align: right;
          }
          &.line-one {
            text-align: left;
            margin-left: 0px;
          }
        }
        > div {
          width: 137px;
          height: 38px;
          border: 1px solid #e7e8eb;
          border-radius: 7px;
          line-height: 38px;
          padding: 0 10px;
          box-sizing: border-box;
          color: #5c5c5c;
          margin: 0 10px;
        }
      }
    }
  }
  .section3 {
    height: 413px;
  }
}
.item-box {
  float: left;
  display: inline-block;
  position: relative;
  .item-label1 {
    color: #0e223d;
    font-weight: 600;
    left: 270px;
    position: absolute;
  }
  .item-label2 {
    color: #0e223d;
    font-weight: 600;
    left: 790px;
    position: absolute;
    // flex:1;
  }
  .item-label3 {
    color: #0e223d;
    font-weight: 600;
    left: 1305px;
    position: absolute;
  }
}
.nodata {
  p {
    font-size: 24px;
    font-weight: 400;
    line-height: 41px;
    color: #6b7179;
    text-align: center;
  }
  img {
    width: 100%;
  }
}
</style>